import React, { useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import styled from "styled-components/macro";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const ItemRoot = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${(p) => p.theme.colors.borderSecondary};
  padding: 9px 12px;
  background: white;
`;
const AddButton = styled(Button)`
  align-self: flex-start;
`;
const RemoveButton = styled(Button)`
  padding: 0;
  height: auto;
  background: none;
  color: ${(p) => p.theme.colors.error} !important;

  &:hover {
    background: none !important;
    color: ${(p) => p.theme.colors.error} !important;
  }
`;
const Item = ({
  onRemove,
  children,
  readonly
}: {
  onRemove: () => void;
  children: React.ReactNode;
  readonly?: boolean;
}) => {
  return (
    <ItemRoot>
      {children}
      <RemoveButton onClick={onRemove} disabled={readonly} type={"text"}>
        Remove
      </RemoveButton>
    </ItemRoot>
  );
};

export const EditableListOfItems = ({
  items,
  onAdd,
  onRemove,
  addNewButtonLabel,
  addNewModalTitle,
  addNewModalFieldLabel,
  addNewModalFieldError,
  readonly
}: {
  items: string[] | null;
  onAdd: (item: string) => void;
  onRemove: (item: string) => void;
  addNewButtonLabel: string;
  addNewModalTitle: string;
  addNewModalFieldLabel: string;
  addNewModalFieldError: string;
  readonly?: boolean;
}) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [newItemText, setNewItemText] = useState("");
  const existError = items?.includes(newItemText);

  return (
    <Root>
      {items?.map((item) => (
        <Item
          key={item}
          onRemove={() => {
            onRemove(item);
          }}
          readonly={readonly}
        >
          {item}
        </Item>
      ))}
      <AddButton
        onClick={() => {
          setShowAddModal(true);
        }}
        icon={<PlusOutlined />}
        type={"text"}
        disabled={readonly}
      >
        {addNewButtonLabel}
      </AddButton>
      {showAddModal ? (
        <Modal
          title={addNewModalTitle}
          open={showAddModal}
          onOk={() => {
            onAdd(newItemText);
            setNewItemText("");
            setShowAddModal(false);
          }}
          onCancel={() => {
            setShowAddModal(false);
          }}
          okButtonProps={{
            disabled: existError || newItemText.length === 0
          }}
        >
          <Form.Item
            label={addNewModalFieldLabel}
            validateStatus={existError ? "error" : ""}
            help={existError ? addNewModalFieldError : ""}
          >
            <Input
              size={"large"}
              value={newItemText}
              onChange={(e) => {
                setNewItemText(e.target.value);
              }}
            />
          </Form.Item>
        </Modal>
      ) : null}
    </Root>
  );
};
